import { Application } from '../../../../../application/application'
import { Options } from './interfaces'

export function isBackgroundCheckStep(
  application: Application,
  options: Options
) {
  const { isAtCapacity } = options
  const hasCitizenship = application.citizenshipStatus
  const hasDasher = !!application.dasherId
  const hasDob = !!application.dateOfBirth

  return !isAtCapacity && !hasCitizenship && (!hasDasher || !hasDob)
}
